window.addEventListener('DOMContentLoaded', (ev) => {

	$ = jQuery;

	for (const key in RPMModules) {
		if (RPMModules.hasOwnProperty(key)) {
			const block = RPMModules[key];
			block.init();
		}
	} 

});
